/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Target_Event_GroupInputs */

const en_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Event Group`)
};

const fr_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements cibles`)
};

const de_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielgruppe der Veranstaltung`)
};

const it_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Event Group`)
};

const ru_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая группа мероприятий`)
};

const es_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo objetivo del evento`)
};

const zh_cn2_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标事件组`)
};

const ja_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象イベントグループ`)
};

const hi_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य घटना समूह`)
};

const pt_pt2_live_caption_target_event_group = /** @type {(inputs: Live_Caption_Target_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos Alvo`)
};

/**
* | output |
* | --- |
* | "Target Event Group" |
*
* @param {Live_Caption_Target_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_target_event_group = /** @type {((inputs?: Live_Caption_Target_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Target_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_target_event_group(inputs)
	if (locale === "de") return de_live_caption_target_event_group(inputs)
	if (locale === "it") return it_live_caption_target_event_group(inputs)
	if (locale === "ru") return ru_live_caption_target_event_group(inputs)
	if (locale === "es") return es_live_caption_target_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_target_event_group(inputs)
	if (locale === "ja") return ja_live_caption_target_event_group(inputs)
	if (locale === "hi") return hi_live_caption_target_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_target_event_group(inputs)
	return en_live_caption_target_event_group(inputs)
});